// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"55b14bc7","104":"0347c668","126":"7797f997","411":"9bd894a3","649":"24df7209"}[chunkId] + ".chunk.js";
};